/* cm-layout.js: custommobility.net layout behaviour (stage 2, 2026-10-12).
   1. Grid stagger reveal (cards and tiles fade up in turn).
   2. Photo strips: a looping strip with back / pause / forward, as on mymobilitycenter.com.
   Additive only: with JavaScript off or reduced motion requested, everything is in its final place. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Stagger ---------- */
  var GRIDS = '.cm-cards, .cm-tiles, .cm-regions, .cm-az__tiles, .why-choose-us__grid, .service-grid__items, .industries-served__grid, ' +
    '.product-features__grid, .featured-collections__grid, .sub-collections__grid, .process-steps__grid, .services-strip__grid, ' +
    '.state-coverage__details-grid, .location-cards__grid, .feature-boxes__grid';
  function initStagger() {
    var grids = document.querySelectorAll(GRIDS);
    if (!grids.length) return;
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
    Array.prototype.forEach.call(grids, function (g) {
      // a grid already on screen at load is shown at once
      var r = g.getBoundingClientRect();
      g.classList.add('cm-stagger');
      if (r.top < window.innerHeight && r.bottom > 0) { requestAnimationFrame(function () { g.classList.add('is-in'); }); return; }
      io.observe(g);
    });
  }

  /* ---------- 2. Photo strips ---------- */
  function initStrips() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cm-strip]'), function (set) {
      var track = set.querySelector('.cm-strip-track');
      if (!track || track.dataset.cloned === '1') return;
      // the keyframe moves the track by half its width, so the content exists twice
      Array.prototype.slice.call(track.children).forEach(function (item) {
        var c = item.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.setAttribute('tabindex', '-1');
        var img = c.querySelector('img'); if (img) img.setAttribute('alt', '');
        track.appendChild(c);
      });
      track.dataset.cloned = '1';
      var half = track.scrollWidth / 2;
      track.style.setProperty('--cm-strip-dur', Math.max(34, Math.round(half / 30)) + 's');

      var pauseBtn = set.querySelector('[data-strip-pause]');
      var prevBtn = set.querySelector('[data-strip-prev]');
      var nextBtn = set.querySelector('[data-strip-next]');

      function resume() {
        if (track.dataset.offset === undefined) return;
        var h = track.scrollWidth / 2;
        var done = h ? -parseFloat(track.dataset.offset) / h : 0;
        var dur = parseFloat(track.style.getPropertyValue('--cm-strip-dur')) || 60;
        delete track.dataset.offset;
        track.style.transition = '';
        track.style.transform = '';
        track.style.animation = '';
        track.style.animationDelay = (-done * dur) + 's';
      }
      function setPaused(state) {
        set.classList.toggle('is-paused', state);
        if (pauseBtn) {
          pauseBtn.setAttribute('aria-pressed', state ? 'true' : 'false');
          pauseBtn.setAttribute('aria-label', state ? pauseBtn.dataset.labelPlay : pauseBtn.dataset.labelPause);
        }
        if (!state) resume();
      }
      function step(dir) {
        setPaused(true);
        var tile = track.querySelector('.cm-strip-shot');
        var by = tile ? tile.getBoundingClientRect().width + 12 : 200;
        var h = track.scrollWidth / 2;
        var cur;
        if (track.dataset.offset === undefined) {
          var m = window.getComputedStyle(track).transform;
          cur = m && m !== 'none' ? new DOMMatrix(m).m41 : 0;
        } else {
          cur = parseFloat(track.dataset.offset);
        }
        cur -= dir * by * 2;
        if (cur > 0) cur -= h;
        if (cur < -h) cur += h;
        track.style.animation = 'none';
        track.style.transition = reduce ? 'none' : 'transform .45s cubic-bezier(.2,.7,.3,1)';
        track.style.transform = 'translate3d(' + cur + 'px,0,0)';
        track.dataset.offset = String(cur);
      }
      if (pauseBtn) pauseBtn.addEventListener('click', function () { setPaused(!set.classList.contains('is-paused')); });
      if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
      if (reduce) setPaused(true);
    });
  }

  function init() { initStagger(); initStrips(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
